module.exports = __webpack_public_path__ + "static/media/carlisle_homepage.a12b450d.png";